import { useState } from "react";
import { Waves, Wifi, Snowflake, CookingPot, Coffee, Flame, WashingMachine, Tv, Car, Sun, ShowerHead, TreePalm, UtensilsCrossed, BookOpen, Check } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { Reveal } from "@/components/site/Reveal";

export const AMENITY_ICONS = {
  beach_access: Waves, wifi: Wifi, ac: Snowflake, kitchen: CookingPot, coffee_maker: Coffee, oven: Flame,
  washer_dryer: WashingMachine, smart_tv: Tv, parking: Car, hammock: Sun, outdoor_shower: ShowerHead,
  garden: TreePalm, outdoor_dining: UtensilsCrossed, books_games: BookOpen,
};

export const Amenities = ({ prop }) => {
  const { t } = useI18n();
  const [all, setAll] = useState(false);
  const list = Array.isArray(prop?.amenities) ? prop.amenities : [];
  const shown = all ? list : list.slice(0, 10);
  return (
    <section id="amenities" className="border-t border-ink/10 pt-10" data-testid="amenities-section">
      <Reveal><h3 className="font-display text-3xl text-ink">{t("am.title")}</h3></Reveal>
      <div className="mt-7 grid gap-x-8 gap-y-5 sm:grid-cols-2">
        {shown.map((k, i) => {
          const I = AMENITY_ICONS[k] || Check;
          return (
            <Reveal key={k} delay={(i % 6) * 0.04} className="flex items-center gap-4 text-[15px] text-ink">
              <I className="h-6 w-6 shrink-0 text-muted2" strokeWidth={1.4} /> <span data-testid={`amenity-${k}`}>{t(`am.${k}`)}</span>
            </Reveal>
          );
        })}
      </div>
      {list.length > 10 && (
        <button data-testid="amenities-toggle" onClick={() => setAll(!all)} className="mt-8 rounded-xl border border-ink px-6 py-3 text-sm font-semibold transition-colors hover:bg-ink hover:text-paper">
          {all ? t("about.less") : `${t("about.more")} (${list.length})`}
        </button>
      )}
    </section>
  );
};
